import { createFileRoute } from "@tanstack/react-router"
import { WorkflowsPage } from "./-WorkflowsPage"

export const Route = createFileRoute("/media-space/workflows")({
  component: WorkflowsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    tab: (search.tab as string) || "workflows",
    wf: (search.wf as string) || undefined,
    exec: (search.exec as string) || undefined,
  }),
})
